if (!customElements.get('product-gallery-navigation')) {
  customElements.define(
    'product-gallery-navigation',
    class ProductGalleryNavigation extends HTMLElement {
      connectedCallback() {
        this.galleryRoot = this.closest('.product-gallery-with-nav');
        this.mediaGallery = this.galleryRoot?.querySelector('media-gallery');
        this.viewer = this.mediaGallery?.querySelector('[id^="GalleryViewer"]');
        this.prevButton = this.querySelector('[name="previous"]');
        this.nextButton = this.querySelector('[name="next"]');
        this.progressBar = this.querySelector('.product-gallery-progress');
        this.progressFill = this.querySelector('.product-gallery-progress__fill');

        if (!this.viewer || !this.prevButton || !this.nextButton) return;

        this.slider = this.viewer.querySelector('[id^="Slider-"]');

        this.prevButton.addEventListener('click', () => this.go(-1));
        this.nextButton.addEventListener('click', () => this.go(1));
        this.viewer.addEventListener('slideChanged', () => this.syncActiveSlide());
        if (this.slider) {
          this.slider.addEventListener('scroll', this.onSliderScroll.bind(this), { passive: true });
        }

        requestAnimationFrame(() => this.updateUI());
      }

      onSliderScroll() {
        if (this.scrollRaf) return;
        this.scrollRaf = requestAnimationFrame(() => {
          this.scrollRaf = null;
          this.syncActiveSlide();
        });
      }

      syncActiveSlide() {
        const slides = this.getSlides();
        if (slides.length < 2) {
          this.updateUI();
          return;
        }

        const index = this.getActiveIndex(slides);
        slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === index);
        });
        this.updateUI();
      }

      getSlides() {
        return Array.from(this.viewer.querySelectorAll('.product__media-item[data-media-id]'));
      }

      getScrollIndex(slides) {
        if (!this.slider || slides.length === 0) return 0;

        const scrollLeft = this.slider.scrollLeft;
        let closest = 0;
        let minDistance = Infinity;

        slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - scrollLeft);
          if (distance < minDistance) {
            minDistance = distance;
            closest = index;
          }
        });

        return closest;
      }

      getActiveIndex(slides) {
        if (this.slider && this.slider.scrollWidth > this.slider.clientWidth + 1) {
          return this.getScrollIndex(slides);
        }

        const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (activeIndex >= 0) return activeIndex;

        return this.getScrollIndex(slides);
      }

      go(direction) {
        const slides = this.getSlides();
        if (slides.length < 2) return;

        const currentIndex = this.getActiveIndex(slides);
        const nextIndex = currentIndex + direction;
        if (nextIndex < 0 || nextIndex >= slides.length) return;

        const mediaId = slides[nextIndex].dataset.mediaId;

        const targetSlide = slides[nextIndex];

        if (this.mediaGallery?.setActiveMedia) {
          this.mediaGallery.setActiveMedia(mediaId, false);
        }

        window.setTimeout(() => this.updateUI(), 50);
      }

      updateUI() {
        const slides = this.getSlides();
        const index = slides.length ? this.getActiveIndex(slides) : 0;

        if (slides.length < 2) {
          this.toggleDisabled(this.prevButton, true);
          this.toggleDisabled(this.nextButton, true);
        } else {
          this.toggleDisabled(this.prevButton, index <= 0);
          this.toggleDisabled(this.nextButton, index >= slides.length - 1);
        }

        if (this.progressFill && slides.length > 0) {
          const segmentWidth = 15;
          const slotWidth = 100 / slides.length;
          const offset = index * slotWidth;

          this.progressFill.style.width = `${segmentWidth}%`;
          this.progressFill.style.left = `${offset}%`;
        }

        if (this.progressBar && slides.length > 0) {
          this.progressBar.setAttribute('aria-valuenow', index + 1);
          this.progressBar.setAttribute('aria-valuemax', slides.length);
        }
      }

      toggleDisabled(button, disabled) {
        button.disabled = disabled;
        button.classList.toggle('product-navigation__link--disabled', disabled);
        button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }
    }
  );
}
